import { Component, OnInit, Input } from '@angular/core';
import {Router,ActivatedRoute } from '@angular/router';
import { JobService } from '../../services/job/job.service';
import {environment} from '../../../../../environments/environment'
import { InspectionListService } from '../../../../inspection-list/inspection-list.service';
import { OVERVIEW_PANELS, OverviewLayoutItem, defaultOverviewLayout, migrateOverviewLayout } from './overview-panels';
import { IntakeAccessService } from '../../intake-access.service';
import { ShellService } from '../../../../shell/shell.service';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss']
})
export class OverviewComponent implements OnInit {
  page_title="Inspection: Review";
  public oldSite;
  jobId;
  userData;

  // The three drag-and-drop columns; see overview-panels.ts for what each item is.
  readonly panels = OVERVIEW_PANELS;
  todo: OverviewLayoutItem[] = [];
  inProgress: OverviewLayoutItem[] = [];
  done: OverviewLayoutItem[] = [];
	constructor(
    // private commonService: CommonService,
    private jobService: JobService,
    private _router: Router,
    private router: ActivatedRoute,
    private inspectionList: InspectionListService,
    private intakeAccess: IntakeAccessService,
    private shell: ShellService,
  ) {


  }

  // Home / Termite inspections (HOME_INSPECTIONS): the Status card's Home row and the Home
  // Inspection Notes panel. Off, the page is as before (one Notes panel, no service rows).
  homeInspections = false;

  // "Inspection scheduled successfully" banner, once, after Scheduling saves (it sets
  // sessionStorage 'im-scheduled' to the job id).
  scheduledBanner = false;

  // Mockup "Inspection Status" chip: the top status when it is final (Completed, Hold,
  // Cancelled, Deleted), otherwise the stage (Intake / Inspection / Work).
  get inspectionStatus(): string {
    const job = this.job || {};
    const top = job.job_status_top || '';
    if (top && top !== 'Active') {
      return ({ Completed: 'Complete', Hold: 'On Hold' } as any)[top] || top;
    }
    return job.job_status || top || 'Intake';
  }

  get inspectionStatusClass(): string {
    const top = (this.job && this.job.job_status_top) || '';
    return top === 'Completed' ? 'complete' : top === 'Hold' ? 'hold' : (top === 'Cancelled' || top === 'Deleted') ? 'cancelled' : 'active';
  }

	ngOnInit() {
    this.oldSite = environment.apiSite;
    this.router.params.subscribe(params => {
        if(params.jobId){
            try {
                if (sessionStorage.getItem('im-scheduled') === String(params.jobId)) {
                    this.scheduledBanner = true;
                }
                sessionStorage.removeItem('im-scheduled');
            } catch (e) { }
            this.jobId = params.jobId;
            console.log(this.jobId)
            this.getJob(this.jobId);
        }
    })
    this.userData = JSON.parse(localStorage.getItem('user'));
    this.shell.homeInspections$.subscribe(enabled => this.homeInspections = enabled);
    this.loadState();
    this.loadAccess();
  }

  onDrop(event: any, targetList: string) {
    this.saveState();
  }

  loadState() {
    let layout = defaultOverviewLayout();
    const savedState = localStorage.getItem('dragDropState');
    if (savedState) {
      try {
        layout = migrateOverviewLayout(JSON.parse(savedState));
      } catch (e) {}
    }
    this.todo = layout.todo;
    this.inProgress = layout.inProgress;
    this.done = layout.done;
  }

  // What this user may do here, as twin-ci decides it (Laravel UserAccess, same rules as the
  // Inspections list): change status = administrators, or staff whose level has
  // "Inspections - Status"; order logs = administrators only. Until it loads, or if it fails,
  // only administrators get either.
  canChangeStatus = false;
  canViewLogs = false;
  loadAccess() {
    const isAdmin = this.userData && this.userData.user_level == 'administrator';
    this.canChangeStatus = isAdmin;
    this.canViewLogs = isAdmin;
    this.inspectionList.overviewAccess().subscribe(
      access => {
        if (access && access.can) {
          this.canChangeStatus = !!access.can.status;
          this.canViewLogs = !!access.can.logs;
        }
      },
      () => {}
    );
    this.intakeAccess.access().subscribe(access => this.canEditIntake = access.intake);
  }

  // The panels' Edit links open the Property / Client pages: only for users who may open them
  // (IntakeAccessService - administrators, staff with twin-ci's "Status Bar - Intake").
  canEditIntake = false;

  get isInspector(): boolean {
    return this.userData && this.userData.user_level == 'inspector';
  }

  saveState() {
    const state = {
      todo: this.todo,
      inProgress: this.inProgress,
      done: this.done
    };
    localStorage.setItem('dragDropState', JSON.stringify(state));
  }
  job: any = [];
  is_loading=true;
  is_error: any = '';
  getJob(jobid){
    this.jobService.getjobDetails(jobid).subscribe(
      data => {
       this.is_loading=false;
       if(data.data){
        this.job = data.data as string[];
        this.checkPermission(data.data.job_status)
        this.accounting(jobid)
       }

      },
      error=>{
        this.is_loading=false;
        this.is_error = error;
        console.log(error)
      }
    );
  }
  balance:any
  accounting(jobid){
      this.jobService.accounting(jobid).subscribe(
        data => {
          this.balance = data
        }
      );
  }

  // job/order notify
  onNotify(event):void{
    console.log("Ads",event.job_status)
    this.checkPermission(event.job_status)
  }
  permission = '';
  checkPermission(status){
    console.log('sd',status)
    if (status == 'Inspection' ||status == 'Work'|| status == 'Intake'||status == 'Completed' ) {
      // inspections_completed_sheet
      this.permission="allow";
    } else if (status == 'Cancelled') {
      // MAY 16TH 2023, CHANGING THIS TO "allow" AFTER
      // ADDING A WARNING ON CANCELLED INSPECTIONS
      this.permission="allow";
        // inspections_cancelled_confirmation
    } else {
      this.permission="permission_denied";
        // permission_denied
    }
    console.log('permission',this.permission)
  }

}
